import { ErrorPage } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { useGetBackOfficeGetPaymentQuery } from "../../../api/payment.generated";
import { ParamId } from "../../../enums/types";
import { makeRoute } from "../../../hooks/route";
import { PageLoader } from "../../loader/PageLoader";
import { AllRoutes } from "../../route/Route";
import { PaymentCard } from "../molecules/PaymentCard";
import { UserPaymentCard } from "../molecules/UserPaymentCard";

export function PaymentsDetailPageContent() {
  const { id }: ParamId = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isFetching, currentData, isError } = useGetBackOfficeGetPaymentQuery({
    id: id || "",
  });

  if (isError) {
    return (
      <ErrorPage
        errorMessageText={t("app.page.error.page.not.found")}
        messageForUser={t("app.page.error.defaultMessage")}
        hasGoBackButton
        buttonText={t("app.goToDasboard")}
        onButtonClick={() => navigate(makeRoute(AllRoutes.DASHBOARD))}
      />
    );
  }

  return (
    <div className="flex w-full min-w-full">
      {isFetching ? (
        <PageLoader />
      ) : (
        <div className="flex">
          <div className="w-full">
            <PaymentCard currentData={currentData} />
          </div>
          <div className="w-1/2">
            <UserPaymentCard currentData={currentData} />
          </div>
        </div>
      )}
    </div>
  );
}
